import { useState } from 'react';

import { IntakeTable, MatchStudy } from './ImagingPage';
import { type Study, useImagingCapabilities } from './api';
export function ImagingInbox() {
  const cap = useImagingCapabilities();
  const [study, setStudy] = useState<Study | null>(null);
  if (!cap.data?.permissions.includes('intake_imaging')) return null;
  return (
    <section className="flex flex-col gap-4">
      <IntakeTable onMatch={setStudy} />
      {study && <MatchStudy key={study.id} study={study} close={() => setStudy(null)} />}
    </section>
  );
}
